import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Global/Buttons/Button';
import Icon from '../Global/Icons/Icon';

const NewFolderButton = ({ onClick }) => (
  <Button onClick={onClick} classes="content-list-new__list-item link--tertiary fw-medium" faux>
    <Icon name="folder-new" size="m" />
    <span>New folder</span>
  </Button>
);

NewFolderButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default NewFolderButton;



// WEBPACK FOOTER //
// ./library/app/components/Folders/NewFolderButton.js